import { WEBCHAT } from 'Constants/normalize-module';
import { API_CONSULT } from 'Constants/client-modules';
import { invitationSchema } from 'Schemas/schemas';

import * as ACTION_TYPES from './types';

export function inviteDoctorsToConsult(consultId, body = {}) {
  return {
    types: [
      ACTION_TYPES.INVITATION_CREATE_REQUESTED,
      ACTION_TYPES.INVITATION_CREATE_SUCCEED,
      ACTION_TYPES.INVITATION_CREATE_FAILED,
    ],
    promise: client => client.post(`/consults/${consultId}/doctors`, body),
    options: {
      clientName: API_CONSULT,
    },
    meta: {
      schema: {
        data: invitationSchema,
      },
      module: WEBCHAT,
    },
  };
}

export function resetInvitationState() {
  return {
    type: ACTION_TYPES.INVITATION_RESET_STATE,
    payload: {},
  };
}
